module.exports = __webpack_public_path__ + "media/images/front/icon_memo-991732f2bb87feb0da95077faee7411c.png";